module.exports = __webpack_public_path__ + "static/img/icon4.f2448aea.png";